import {useCallback} from 'react';

export function useNumberKeyDown(schema) {
  const handleKeyDown = useCallback(
    (e) => {
      const {key} = e;
      const inputElement = e.target;
      const currentValue = inputElement ? inputElement.value : '';

      if (schema?.restrictDecimal) {
        if (
          ['.', ',', 'e', '-'].includes(key) ||
          (!currentValue && key === '0')
        ) {
          e.preventDefault();
        }
      } else if (schema?.type === 'number') {
        if (['e', 'E', '+', '-', ','].includes(key)) {
          e.preventDefault();
          return;
        }

        if (['ArrowUp', 'ArrowDown'].includes(key)) {
          e.preventDefault();
          return;
        }

        if (/^\d$/.test(key)) {
          const decimalIndex = currentValue.indexOf('.');
          if (decimalIndex !== -1) {
            const decimalPlaces = currentValue.substring(
              decimalIndex + 1
            ).length;
            if (decimalPlaces >= 2) {
              e.preventDefault();
            }
          }
        }
      }
    },
    [schema?.restrictDecimal, schema?.type]
  );

  return handleKeyDown;
}
